import { signal } from "@preact/signals-react";
import { logToken } from "./login.signal";

export const couponsType = signal(null);
export const couponsData = signal(null);
export const PropCouponTypeData = signal("");
export const PropCouponColor = signal("");
export const CommissionsPolicy = signal(null);

export async function fetchCouponsApi(CouponTypeData) {
  const url = "https://alguthmi.co/API/B2BAppAPI/fetchCoupons.php";
  const bearerToken = logToken.value;
  const options = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      origin: "http://alguthmi.co",
    },
    body: JSON.stringify({
      COUPON_TYPE: CouponTypeData,
    }),
  };

  try {
    const response = await fetch(url, options);

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error:", error);
  }
}

export async function fetchCoupons() {
  const url = "https://alguthmi.co/API/B2BAppAPI/fetchCouponsCat.php";
  const bearerToken = logToken.value;
  const options = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      origin: "http://alguthmi.co",
    },
    body: JSON.stringify({}),
  };

  try {
    const response = await fetch(url, options);

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error:", error);
  }
}

export async function fetchCommissionsPolicy() {
  const url = "https://alguthmi.co/API/B2BAppAPI/fetchCommissionsPolicy.php";
  const bearerToken = logToken.value;
  const options = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      origin: "http://alguthmi.co",
    },
    body: JSON.stringify({}),
  };

  try {
    const response = await fetch(url, options);

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error:", error);
  }
}
